<div class="row" [ngClass]="{'d-none': options.formState.disabled }">
  <div class="col-4">
    <mat-label class="custom-label" [ngClass]="{'d-none': !to.customLabel }">{{ to.customLabel }}</mat-label>
    <app-file-uploader [upload]="triggerFileUpload" [fileReset]="triggerFileReset"
      [allowedFilesNumber]="to.allowedFilesNumber" [allowedFilesExt]="to.allowedFilesExtensions"
      (uploadFiles)="onUploadFiles($event)">
    </app-file-uploader>
  </div>
  <div class="col-8 d-flex">
    <div class="img-preview-structure-box" *ngFor="let file of filesToUpload">
      <button mat-mini-fab color="warn" matTooltip="{{ 'common.cta.remove' | translate }}"
        class="d-none d-sm-inline-block remove-button" (click)="onRemove(file)">
        <mat-icon fontSet="fal" fontIcon="fa-trash"></mat-icon>
      </button>
      <app-card-spinner [visible]="imageLoader" type="zero"></app-card-spinner>
      <img *ngIf="!imageLoader" src="{{ file.path }}" alt="{{ file.originalName }}" (click)="onOpenImage(file)"  (load)="this.imageLoader = false">
    </div>
  </div>
</div>

<div class="row" *ngIf="uploadedFiles && uploadedFiles.length">
  <div class="col-12">
    <mat-label class="uploaded-files-label">{{ 'properties.structures.uploadedFiles' | translate }}</mat-label>
    <div class="uploaded-files-list">
      <div class="uploaded-file-card" *ngFor="let file of uploadedFiles">
        <div class="uploaded-file-thumb">
          <button mat-mini-fab color="warn" matTooltip="{{ 'common.cta.remove' | translate }}"
            class="d-none remove-button" (click)="onRemoveUploadedFile(file)"
            [ngClass]="{'d-inline-block': !options.formState.disabled }">
            <mat-icon fontSet="fal" fontIcon="fa-trash"></mat-icon>
          </button>
          <app-card-spinner [visible]="imageLoader" type="zero"></app-card-spinner>
          <img *ngIf="!imageLoader" src="{{ file.path }}" alt="{{ file.originalName }}" (click)="onOpenImage(file)" (load)="this.imageLoader = false">
        </div>
        <div class="uploaded-file-info" *ngIf="file.createdAt">
          <span class="uploaded-file-date">
            <mat-icon fontSet="fal" fontIcon="fa-clock" class="fa-fw"></mat-icon>
            {{ file.createdAt | dateTimeFormat }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
